<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/189qDrn/tc-custom/9781459201811.jpg?1720280501135" alt="This image is the cover for the book Not a Marrying Man"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Not a Marrying Man
      </h1>
      <p class="bookDescription body article font2">
        <p>British billionaire Warwick Kincaid likes to take risksthough they don't include marriage and children. Twelve months is his limit when it comes to relationships.<br/><br/>Warwick asks beautiful Australian receptionist Amber Roberts to move into his luxury Sydney penthouse, and she dares to hope he might have changed. But after they've been together ten months Warwick starts to act cold and withdrawn. Is Amber's time up, just like the women before her? The chemistry between them remains <i>red-hot</i> and she finds it hard to believe that her time with Warwick is <i>really</i> over.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Miranda Lee
      </h2>
      
      <p class="authorDescription body article">After leaving her convent school, Miranda Lee briefly studied the cello before moving to Sydney, where she embraced the emerging world of computers. Her career as a programmer ended after she married, had three daughters and bought a small acreage in a semi-rural community. She yearned to find a creative career from which she could earn money. When her sister suggested writing romances, it seemed like a good idea. She could do it at home, and it might even be fun! She never looked back.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f77cccc